import React, { createContext, useState } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [currentUser, setCurrentUserState] = useState(null);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [adminSearchUserId, setAdminSearchUserId] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [adminSearchUserProfile, setAdminSearchUserProfile] = useState(null);
  
  const [reportsTimePairs, setreportsTimePairs] = useState(null); // 添加 audioReportPathsDic 状态
  const [generatedAudioReport, setGeneratedAudioReport] = useState({ // 新添加的状态
    WAV_File: null,
    log_File: null,
    Data_Records: null
  });


  // 自定义的 setCurrentUser 包装函数，增加日志追踪
  const setCurrentUser = (user) => {
    if (typeof user === 'string') {
      console.error(
        `Unexpected string value assigned to currentUser: ${user}`,
        new Error().stack // 打印调用栈以定位问题源头
      );
    } else {
      console.log('[UserContext] Setting currentUser:', user); // 正常情况下打印
    }
    // console.trace('Stack trace for setCurrentUser'); // 打印完整调用栈
    setCurrentUserState(user); // 正常赋值
  };

  const logoutUser = () => {
    setCurrentUser(null);
    setUserProfile(null);
    setAdminSearchUserProfile(null);
    setIsSuperAdmin(false);
    setreportsTimePairs([]);
    setAdminSearchUserId(null);
    setGeneratedAudioReport({ WAV_File: null, log_File: null, Data_Records: null }); // 清空 generatedAudioReport
  };

  return (
    <UserContext.Provider value={{
      currentUser, setCurrentUser,
      adminSearchUserId, setAdminSearchUserId,
      adminSearchUserProfile,setAdminSearchUserProfile,
      userProfile, setUserProfile,
      isSuperAdmin,setIsSuperAdmin,
      reportsTimePairs, setreportsTimePairs,
      generatedAudioReport, setGeneratedAudioReport, // 提供 generatedAudioReport 和 setGeneratedAudioReport
      logoutUser
    }}>
      {children}
    </UserContext.Provider>
  );
};